import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxMaskModule } from 'ngx-mask';
import { ModalRegisterBankComponent } from "./modal-register-bank.component";

import { MatOptionModule } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from "@angular/material/dialog";
import { RouterModule } from "@angular/router";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { MaterialModule } from "../../material.module";

@NgModule({
  declarations: [ModalRegisterBankComponent],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatOptionModule,
    AutocompleteLibModule,
    RouterModule,
    NgxMaskModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatOptionModule,
    AutocompleteLibModule,
    ModalRegisterBankComponent,
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {},
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class modalRegisterBankModule {}
